module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('van-tabs', {
    staticClass: "tab-nav",
    attrs: {
      "sticky": ""
    },
    on: {
      "click": _vm.onStatusChange
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('van-tab', {
    attrs: {
      "title": "全部"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "秩序册填写"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "项目填写"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "人员统计"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "住宿信息"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "等待付款"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "报名成功"
    }
  }), _vm._v(" "), _c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(order, index) {
    return _c('div', {
      key: index,
      staticClass: "row-list",
      on: {
        "click": function($event) {
          return _vm.goDetail(order)
        }
      }
    }, [_c('div', {
      staticClass: "justify-space-flex row-title"
    }, [_c('div', {
      staticClass: "title-left flex-start gray"
    }, [_c('img', {
      staticClass: "row-title-img",
      attrs: {
        "src": "https://static.dierqudao.com/images/dinghuoxitong/icon-date.png",
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("timeFormat")(order.create_time)) + " 创建")])]), _vm._v(" "), _c('div', [(order.memberstatus == 1) ? _c('van-tag', {
      attrs: {
        "plain": ""
      }
    }, [_vm._v("秩序册填写")]) : (order.memberstatus == 2) ? _c('van-tag', {
      attrs: {
        "plain": ""
      }
    }, [_vm._v("项目填写")]) : (order.memberstatus == 3) ? _c('van-tag', {
      attrs: {
        "plain": ""
      }
    }, [_vm._v("人员统计")]) : (order.memberstatus == 4) ? _c('van-tag', {
      attrs: {
        "plain": ""
      }
    }, [_vm._v("住宿信息")]) : (order.memberstatus == 5) ? _c('van-tag', {
      attrs: {
        "type": "danger",
        "plain": ""
      }
    }, [_vm._v("等待付款")]) : (order.memberstatus == 6) ? _c('van-tag', {
      attrs: {
        "type": "success",
        "plain": ""
      }
    }, [_vm._v("报名成功")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
      staticClass: "justify-space-flex row-goods"
    }, [_c('div', {
      staticClass: "row-left flex-start"
    }, [_c('div', {
      staticClass: "goods-detail"
    }, [_vm._v(_vm._s(order.danwei) + "\n                    "), _c('div', {
      staticClass: "gray-light"
    }, [_vm._v(_vm._s(order.mingcheng))]), _vm._v(" "), _c('div', {
      staticClass: "mt5"
    }, [_vm._v("赛区:" + _vm._s(order.saiqu_name))])])])]), _vm._v(" "), _c('div', {
      staticClass: "row-btn"
    }, [_c('div', {
      staticClass: "look-order"
    }, [_vm._v("查看详情")])])])
  }), 0)], 1)], 1)], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68f9ee98","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/weiyuanhui/apps/sai/SaiApplyList.vue
// module id = 2458
// module chunks = 0